"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConcentrationKickoutMap = void 0;
const common_1 = require("@finley-technologies/common");
const updateConcentrationKickoutMap = ({ multiLoanProductConcentrationKickoutMap, receivable, }) => {
    const concentrationLimitReasons = receivable.concentrationLimitReasons ?? [];
    // *** Managing Creation of Base Data for MLP Concentration for DB ***
    // Evaluate each of the receivables concentration limits to assess which ones are MLP,
    // and if they are, add the kickout impact to the map for later reorganization + store to DB
    for (const concentrationLimit of concentrationLimitReasons) {
        const { concentrationLimitKickout, propertyKey } = concentrationLimit;
        // Just validating this concentration limit is a MLP one and the receivable's LP id
        // is one of the ones affected by this MLP concentration limit
        const multiLoanProductConcentrationKickouts = multiLoanProductConcentrationKickoutMap.get(propertyKey);
        if (!multiLoanProductConcentrationKickouts?.loanProductIds?.has(receivable.loanProductId)) {
            continue;
        }
        const loanProductKickoutMap = multiLoanProductConcentrationKickouts?.kickoutsByLoanProductId;
        (0, common_1.finleyAssert)(loanProductKickoutMap, `Failed to find MLP concentration limit in map [propertyKey:${propertyKey}] [receivableId:${receivable.finleyReceivableId}]`);
        // Store the kickout impact specifically to this loan product for the concentration limit
        const addedKickoutAmount = (loanProductKickoutMap.get(receivable.loanProductId) || 0) +
            concentrationLimitKickout;
        loanProductKickoutMap.set(receivable.loanProductId, addedKickoutAmount);
    }
};
exports.updateConcentrationKickoutMap = updateConcentrationKickoutMap;
//# sourceMappingURL=concentration.js.map